// import Vue from 'vue'
import CryptoJS from 'crypto-js'

 
// AES 秘钥
var AesKey = "dfj3H4Ikh8Bio5LV";
 
// AES-128-CBC偏移量
var CBCIV = "jX3UcG4TCfie7c9R";
 
// 加密选项
var CBCOptions = {
	iv: CryptoJS.enc.Utf8.parse(CBCIV),
	mode:CryptoJS.mode.CBC,
	padding: CryptoJS.pad.Pkcs7
}
 
/**
 * AES加密（CBC模式，需要偏移量）
 * @param data
 * @returns {*}
 */
function encrypt(data){
    var key = CryptoJS.enc.Utf8.parse(AesKey);
    var secretData = CryptoJS.enc.Utf8.parse(data);
    var encrypted = CryptoJS.AES.encrypt(
		secretData, 
		key, 
		CBCOptions
	);
    return encrypted.toString();
}
 
/**
 * AES解密（CBC模式，需要偏移量）
 * @param data
 * @returns {*}
 */
function decrypt(data){
    var key = CryptoJS.enc.Utf8.parse(AesKey);
    var decrypt = CryptoJS.AES.decrypt(
		data, 
		key, 
		CBCOptions
	);
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

var aesUtils = {//加密
  encrypt,
  decrypt
}

export default function(word){
    var utils = aesUtils.encrypt(word);
    var base64 = window.btoa(utils);
    return base64;
}